<script>
import GoogleMap from '@/components/googleMap'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'

export default {
  data () {
    return {
      viewModel: {},
      mapId: 'stationPlace',
      mapId2: 'stayPlace',
      centerPoint: {
        lat: null,
        lng: null
      },
      zoom: 15,
      markPosition: {},
      shiftReservation: {},
      time: {},
      mark: null
    }
  },
  props: {
    flag: {
      type: String,
      default: 'S'
    }
  },
  watch: {
    'centerPoint' (newVal) {
      this.centerPoint = newVal
    }
    // 'mark' (newVal) {
    //   this.mark = newVal
    // }
  },
  methods: {
    initiGoogleMap (labelClass) {
      this.$refs.tMap.initializeGoogleMap().then(() => {
        this.$refs.tMap.map.setCenter(this.centerPoint)
        this.$refs.tMap.map.setZoom(16)
        let markPosition03 = {
          label: this.mark,
          lng: this.centerPoint.lng,
          lat: this.centerPoint.lat,
          icon: STATION_ICON
        }
        // 添加图标
        let imgSize03 = {width: 45, height: 60}
        let className03 = 'staion03-label-class'
        // 图标里面的字体样式
        let labelAnchor03 = {width: 23, height: 53}
        this.$refs.tMap.addSingleMaker(markPosition03, imgSize03, className03, labelAnchor03)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  components: { GoogleMap }
}
</script>

<template>
    <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-staySave" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png"/></button>
                        <h3 class="modal-title" id="myModalLabel" v-text="viewModel.routeType==0?'停留所詳細':'経由地詳細'"></h3>
                    </div>
                    <div class="modal-body">
                        <div class="row clearfix">
                            <div class="col-md-7 column">
                                <table class="table table-bordered window-table">
                                    <tbody>
                                        <tr v-show="viewModel.routeType==0">
                                            <td class="td-key F3-R-15 bgc8">停留所名</td>
                                            <td class="td-value F3-M-18">{{viewModel.name}}</td>
                                        </tr>
                                        <tr v-show="viewModel.routeType==1">
                                            <td class="td-key F3-R-15 bgc8">乗客</td>
                                            <td class="td-value F3-M-18">{{viewModel.name}}</td>
                                        </tr>
                                            <tr v-show="viewModel.routeType==0">
                                            <td class="td-key F3-R-15 bgc8">停留所ID</td>
                                            <td class="td-value F3-M-18">{{viewModel.displayStationId}}</td>
                                        </tr>
                                        <tr v-show="viewModel.routeType==1">
                                            <td class="td-key F3-R-15 bgc8" v-if="viewModel.routeType==1">フリガナ</td>
                                            <td class="td-value F3-M-18">{{viewModel.passengerNameKana}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">所在地</td>
                                            <td class="td-value F3-M-18">{{viewModel.address}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">緯度</td>
                                            <td class="td-value F3-M-18">{{viewModel.stationLat}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td-key F3-R-15 bgc8">経度</td>
                                            <td class="td-value F3-M-18">{{viewModel.stationLng}}</td>
                                        </tr>
                                        <tr>
                                            <td style="height:200px" class="td-key F3-R-15 bgc8">コメント</td>
                                            <td class="td-value F3-M-18" style="vertical-align: top">{{viewModel.note}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-bordered window-table">
                                    <tbody>
                                        <tr v-show="viewModel.startPointPassengers&&viewModel.startPointPassengers.length>0">
                                            <td class="td-key F3-R-15 bgc8">乗車メンバ—</td>
                                            <td class="td-value F3-M-18">
                                                <label :key="sp" v-for="(item,sp) in viewModel.startPointPassengers">{{item.name}}<span v-if="sp!=viewModel.startPointPassengers.length-1">、</span></label>
                                            </td>
                                        </tr>
                                        <tr v-show="viewModel.arrivePointPassengers&&viewModel.arrivePointPassengers.length>0">
                                            <td class="td-key F3-R-15 bgc8">降車メンバ—</td>
                                            <td class="td-value F3-M-18">
                                                <label :key="ap" v-for="(item,ap) in viewModel.arrivePointPassengers">{{item.name}}<span v-if="ap!=viewModel.arrivePointPassengers.length-1">、</span></label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-5 column">
                                <div class="mapCss">
                                    <GoogleMap ref="tMap" :center-point="centerPoint" :map-id="mapId2">
                                    </GoogleMap>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
label {
  font-weight:300;
}
.modal-dialog{
    width: 80%;
    margin-top: 4%;
}
.modal-header{
    border-bottom: 0px;
}
.modal-body{
    padding-left: 40px;
    padding-right: 40px;
}
.window-table{
    font-size: 16px;
    border: 2px solid rgb(148, 148, 148);
}
.table-bordered>tbody>tr>td{
    border: 1px solid rgb(148, 148, 148);
}
.td-title{
    background-color: #797979;
    color: #fff;
    font-size: 22px
}
.td-key{
    width: 30%;
    background-color: #DDDDDD;
}
.table>tbody>tr>td{
    height: 50px;
    vertical-align: middle;
}
.table>tbody>tr>.td-value{
    padding-left: 30px;
}
.td-value{
    text-align: left;
    border: 1px solid #959595;
}
.boottom{
    margin-top: 2%;
    width: 100%
}
.window-button{
    width: 30%;
    height: 50px;
    border-radius: 10px;
    font-size: 2em;
    color: #fff;
    background-color: #717171;
}
.close{
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/StationDetailedConfirm.vue